export default __webpack_public_path__ + "static/media/shareBackground.3d498928.png";